import React from 'react'

import { GridToolContext } from '@integec/grid-tools'

const gridContextOptions = {
  debug: false,
  columnHeaderProps: {
    color: 'white',
    backgroundColor: '#eee',
    fontWeight: 'bold',
    fontSize: '0.85em',
  },
  dropDownZIndex: 10000,
}

const GadsGridContextProvider = ({ children }) => {
  return (
    <GridToolContext.Provider value={gridContextOptions}>
      {children}
    </GridToolContext.Provider>
  )
}

export default GadsGridContextProvider
